import { render, staticRenderFns } from "./ActivitiesTimelineItem.vue?vue&type=template&id=04ba6afc"
import script from "./ActivitiesTimelineItem.vue?vue&type=script&lang=js"
export * from "./ActivitiesTimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports